import { ReactNode } from "react";
import './modal_link.css'
import { useStore } from "../state/state.ts";
import ModalInfoGEG from "../modals/modal_info_geg.tsx";

export default function ModalLink(props:{modal: ReactNode, children: ReactNode}){
      const push_modal = useStore((state) => state.push_modal_closeable);
    
    return  <span className="modal_link" onClick={ ()=>{push_modal(props.modal);} }>
        {props.children}
    </span>;  
}    

export function ModalLinkGEG(){  
  return <ModalLink modal={<ModalInfoGEG/>}>GEG</ModalLink>;  
}    

export function ModalLinkBEG(){  
  return <ModalLink modal={<ModalInfoGEG/>}>BEG</ModalLink>;  
}    

export function ModalLinkSanierungsfahrplan(){  
  return <ModalLink modal={<ModalLinkSanierungsfahrplan/>}>BEG</ModalLink>;  
}    
